import styled from 'styled-components'

const TitleAndTextStyle = styled.div`
	--titleMarginBottom: var(--sp7x);
	--sectionMarginBottom: var(--sp16x);
	--textAndTitleMaxWidth: var(--sp200x);

	margin-bottom: var(--sectionMarginBottom);

	.content-wrap {
		max-width: var(--textAndTitleMaxWidth);

		.title {
			margin-bottom: var(--titleMarginBottom);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--titleMarginBottom: var(--sp5x);
		--sectionMarginBottom: var(--sp13x);
		--textAndTitleMaxWidth: var(--sp150x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionMarginBottom: var(--sp11x);
		--textAndTitleMaxWidth: var(--sp117x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionMarginBottom: var(--sp8x);
		--textAndTitleMaxWidth: var(--sp112x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--titleMarginBottom: var(--sp4x);
		--sectionMarginBottom: var(--sp7x);
		--textAndTitleMaxWidth: var(--sp100x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--titleMarginBottom: var(--sp3x);
		--sectionMarginBottom: var(--sp7x);
		--textAndTitleMaxWidth: var(--sp98x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--titleMarginBottom: var(--sp3x);
		--sectionMarginBottom: var(--sp7x);
		--textAndTitleMaxWidth: 100%;
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--titleMarginBottom: var(--sp3x);
		--sectionMarginBottom: var(--sp6x);
		--textAndTitleMaxWidth: 100%;
	}
`

export default TitleAndTextStyle
